import { ErrorBoundary } from './components/ErrorBoundary'
import { sentryCreateBrowserRouter } from './libs/instrument'
import { ProtectedGuestRoute } from './pages/Guest/components/ProtectedGuestRoute'
import { GuestReportDetails } from './pages/Guest/GuestReportDetails'
import { HaveNoPassword } from './pages/HaveNoPassword'
import { ProtectedRoute } from './pages/protected/components/ProtectedRoute'
import { Dashboard } from './pages/protected/Dashboard'
import { Products } from './pages/protected/Products'
import { Profile } from './pages/protected/Profile'
import { PromotersCompanies } from './pages/protected/PromotersCompanies'
import { Reports } from './pages/protected/reports'
import { ReportDetails } from './pages/protected/reports/Details'
import { Stores } from './pages/protected/Stores'
import { Logs } from './pages/protected/SystemLogs'
import { Terms } from './pages/protected/Terms'
import { TradeMarketingDailyCheck } from './pages/protected/TradeMarketingDailyCheck'
import { Users } from './pages/protected/Users'
import { SignIn } from './pages/SignIn'

export const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <SignIn />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/have-no-password',
    element: <HaveNoPassword />,
    errorElement: <ErrorBoundary />,
  },

  {
    element: <ProtectedRoute />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/logs', element: <Logs /> },
      { path: '/terms', element: <Terms /> },
      { path: '/reports', element: <Reports /> },
      { path: '/reports/:id?', element: <ReportDetails /> },
      { path: '/users', element: <Users /> },
      { path: '/stores', element: <Stores /> },
      { path: '/promoters-companies', element: <PromotersCompanies /> },
      { path: '/trade-marketing-daily-check', element: <TradeMarketingDailyCheck /> },
      { path: '/products', element: <Products /> },
      { path: '/profile', element: <Profile /> },
    ],
  },
  {
    element: <ProtectedGuestRoute />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: '/temporary-access/:id', element: <GuestReportDetails /> },
    ],
  },
])
